<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="tab">
          <div :class="{ active: currentTab == 0 }" @click="showContent(0)">Thông tin chung</div>
          <div :class="{ active: currentTab == 1 , 'hide-tab' : hideTab == 1}" @click="showContent(1)">Modules</div>
      </div>
      <div :class="{ content : true, active: currentTab == 0 }">

      <div class="">
        <div class="">
          <label class="txt-right required">Tên công ty</label>
          <!-- <div class="p-col"> -->
          <InputText
            v-model="name"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="name" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Tên đăng nhập</label>
          <!-- <div class="p-col"> -->
          <InputText
            :disabled="mode=='edit'"
            v-model="username"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="username" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Người đại diện</label>
          <!-- <div class="p-col"> -->
          <InputText
            
            v-model="fullname"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="fullname" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Số điện thoại</label>
          <!-- <div class="p-col"> -->
          <InputText
            
            v-model="phone"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="phone" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right">Email</label>

          <InputText
            
            v-model="email"
            type="text"
            class="text-box input-text-box"
            placeholder="mail@example.com"
          />
          <input class="input_tmp_validator" id="email" />
        
        </div>
        <div class="mt-3">
          <label class="txt-right">Địa chỉ công ty</label>
          <!-- <div class="p-col"> -->
          <Textarea
            v-model="address"
            :autoResize="true"
            rows="1"
            maxlength="500"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="address" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right">Website</label>
          <!-- <div class="p-col"> -->
          <InputText
            v-model="website"
            type="text"
            class="text-box input-text-box"
            placeholder="https://"
          />
          <input class="input_tmp_validator" id="website" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right">Logo công ty</label>
            <input class="input_tmp_validator" id="images">
            <div class="cus-text">Kích thước đề xuất: 500x500px - Dung lượng tối đa: 50 MB</div>
            <div class="cus-text">Định dạng file:: JPG, JPEG, PNG, GIF (không phải ảnh động).</div>
            <input class="p-inputtext p-component text-box" style="background-color: #EEEEEE;" accept="image/*" name="images[]" type="file" @change="onFileSelect"/>
            <div class="box-images mt-3 text-box"  v-if="images && images.length">
              <div class="item-img" v-for="(item, index) in images" :key="index" >
                <div class="button-clear" @click="onFileClear(index)"><img src="../../../assets/ic_clear.svg"/></div>
                <img :src="item.objectURL" width="80" height="80"/>
              </div>
            </div>
        </div>
        <div class="mt-3">
          <label class="txt-right" :class="{ required: mode == 'add' }">Mật khẩu đăng nhập</label>
          <!-- <div class="p-col"> -->
          <CPassword
            
            v-model="password"
            type="password"
            class="text-box input-text-box"
            :toggleMask="true"
            showIcon="pi pi-eye-slash"
            hideIcon="pi pi-eye"
          />
          <input class="input_tmp_validator" id="password" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required" style="margin-bottom: 0px;">Tập đoàn</label>
          <DropdownScrollable 
            placeholder="Chọn tập đoàn" 
            cusClass="text-box input-text-box" 
            :limit="company_group_obj.limit" 
            :loading="company_group_obj.loading" 
            v-model="company_group" 
            :options="company_group_obj.items" 
            :total="company_group_obj.total" 
            @keyup="emitEventCompanyGroup" 
            @offset="changeOffsetCompanyGroup" 
            @scroll="emitEventCompanyGroup"
          />
          <input class="input-group input_tmp_validator" id="company_group_add" />
        </div>
        <div class="mt-3">
          <label class="txt-right required" style="margin-bottom: 0px;">Loại công ty</label>
          <Dropdown v-model="company_type" :options="company_obj" optionLabel="label" placeholder="Chọn" class="text-box input-text-box"/>
          <input class="input-group input_tmp_validator" id="company_type_add" />
        </div>
        <!-- </div> -->
      </div>
      </div>
      <div :class="{ content : true, active: currentTab == 1 }">
        <div class="">
          <div class="">
            <div 
              v-for="item in modules" 
              :key="item.id"
              class="module-item"
            >
              <input 
                type="checkbox" 
                v-model="item.is_approved" 
                style="margin-right: 8px;"
                @click="item.is_approved = !item.is_approved"
              />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
// import DataServices from "@/core/DataServices";
// import { HotModuleReplacementPlugin } from "webpack";
// import gql from "graphql-tag";
import Password from "@/components/Password";
import ApiRepository from "@/core/ApiRepository";
import GetConstants from './../../../core/Constants';
import DropdownScrollable from '@/components/DropdownScrollable_v2';
var Constants = GetConstants.getConstans();
export default {
  components: {
    DropdownScrollable,
    CPassword: Password
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      name: "",
      username: "",
      fullname: "",
      phone: "",
      email: "",
      address: "",
      website: "",
      images: [],
      logo: [],
      password: "",
      maxFiles: 1,
      maxFileSize: 10485760*5,
      imagesDeletes: [],
      uid: null,
      currentTab:0,
      hideTab : 1,
      modules: [],
      company_group_obj: {
        items: [],
        total: 0,
        limit: 20,
        offset: 0,
        loading: false,
        filters: {}
      },
      company_group: {},
      validationErrors: {},
      company_type: { label: 'Thường', value: 'normal' },
      company_obj : [
        { label: 'Thường', value: 'normal' },
        { label: 'Có điểm danh', value: 'option_1' },
      ],
    };
  },
  async mounted() {
    var type_login = this.$store.getters.type ? this.$store.getters.type : null;
    if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN){
      this.hideTab = 0;
    }
    await this.getListCompanyGroup();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.fullname = this.model.user.fullname;
      this.phone = this.model.user.phone;
      this.email = this.model.user.email;
      this.username = this.model.user.username;
      this.name = this.model.name;
      this.address = this.model.address;
      this.website = this.model.website;
      this.uid = this.model.uid;
      if (!this.$commonFuction.isEmpty(this.model.list_files)) {
        let url = this.model.list_files[0]?.file?.url;
        if (url) {
          let split = url.split('/')
          let fileName = split[split.length - 1]
          let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
          this.images.push(obj);
        }
      }
      this.company_group = this.model.company_group;
      this.company_type = this.model.company_type ? this.company_obj.find(item => item.value === this.model.company_type) : { label: 'Thường', value: 'normal' };
      await this.LoadModuleUser(this.model.id);
    }
    await this.sleep(1000);
    if (this.mode !== "edit") {
      console.log("thêm mới");
      //gọi load nhóm quyền
      await this.LoadModuleUser();
    }
  },
  methods: {
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};

      let name_add = document.getElementById("name");
      if (
        this.name == undefined ||
        this.name == null ||
        this.name == ""
      ) {
        name_add.setCustomValidity("Tên công ty không được để trống!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên công ty không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }
      if (this.mode == "add") {
        let username_add = document.getElementById("username");
        const testUsername = /^[a-z0-9_.]+$/;
        if (
          this.username == undefined ||
          this.username == null ||
          this.username == ""
        ) {
          username_add.setCustomValidity("Tên đăng nhập không được để trống!");
        } else if (!testUsername.test(this.username)){
          username_add.setCustomValidity("Tên đăng nhập không hợp lệ!");
        } else if (this.username.length > 50) {
          username_add.setCustomValidity("Tên đăng nhập không được quá 50 ký tự!");
        } else if (await this.existUsername()) {
          username_add.setCustomValidity(`Tên đăng nhập ${this.username} đã tồn tại!`);
        } else {
          username_add.setCustomValidity("");
        }
      }

      let fullname_add = document.getElementById("fullname");
      if (
        this.fullname == undefined ||
        this.fullname == null ||
        this.fullname == ""
      ) {
        fullname_add.setCustomValidity("Người đại diện không được để trống!");
      } else if (this.fullname.length > 255) {
        fullname_add.setCustomValidity("Người đại diện không được quá 255 ký tự!");
      } else {
        fullname_add.setCustomValidity("");
      }

      let phone_add = document.getElementById("phone");
      if (
        this.phone == undefined ||
        this.phone == null ||
        this.phone == ""
      ) {
        phone_add.setCustomValidity("Số điện thoại không được để trống!");
      } else {
        if (isNaN(this.phone)) {
          phone_add.setCustomValidity("Số điện thoại không đúng định dạng!");
        } else if (this.phone.length > 15 || this.phone.length < 9) {
          phone_add.setCustomValidity("Số điện thoại không được quá 15 ký tự!");
        } else {
          phone_add.setCustomValidity("");
        }
      }

      let email_add = document.getElementById("email");
      if (
        this.email == undefined ||
        this.email == null ||
        this.email == ""
      ) {
        email_add.setCustomValidity("");
      } else if (!this.validateEmail()) {
        email_add.setCustomValidity("Email không đúng định dạng!");
      } else if (await this.existEmail()) {
        email_add.setCustomValidity(`Email ${this.email} đã tồn tại!`);
      } else {
        email_add.setCustomValidity("");
      }

      let website_add = document.getElementById("website");
      if (!this.$commonFuction.isEmpty(this.website)) {
        if (!this.validateUrl(this.website)) {
          website_add.setCustomValidity("Website không đúng định dạng!");
        } else {
          website_add.setCustomValidity("");
        }
      } else {
        website_add.setCustomValidity("");
      }
      

      let address_add = document.getElementById("address");
      if (!this.$commonFuction.isEmpty(this.address)) {
        if (this.address.length > 500) {
          address_add.setCustomValidity("Địa chỉ không được quá 500 ký tự!");
        } else {
          address_add.setCustomValidity("");
        }
      } else {
        address_add.setCustomValidity("");
      }
      let password_add = document.getElementById("password");
      if (this.mode == "add") {
        if (
          this.password == undefined ||
          this.password == null ||
          this.password == ""
        ) {
          password_add.setCustomValidity("Mật khẩu không được để trống!");
        } else {
          password_add.setCustomValidity("");
        }
      }

      if (!this.$commonFuction.isEmpty(this.password)) {
        password_add.setCustomValidity(
          (await this.validatePassword()).toString()
        );
      } else if (this.mode == "edit") {
        password_add.setCustomValidity("");
      }

      let company_group_add = document.getElementById("company_group_add");
      if (
        this.$commonFuction.isEmptyObject(this.company_group) ||
        this.$commonFuction.isEmpty(this.company_group)
      ) {
        company_group_add.setCustomValidity("Vui lòng chọn tập đoàn!");
      } else {
        company_group_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateUrl(urlStr) {
      try {
        const url = new URL(urlStr);
        if ((url.protocol === "https:" || url.protocol === "http:") && url.host !== "" && url.pathname !== "") {
          const pattern = new RegExp(
            "^([a-zA-Z]+:\\/\\/)?" + // protocol
              "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
              "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
              "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
              "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
              "(\\#[-a-z\\d_]*)?$", // fragment locator
            "i"
          );
          return pattern.test(urlStr);
        }
        return false;
      }catch(err) {
        console.log(err);
        return false;
      }
    },
    async validatePassword() {
      if (this.password.length < 8) {
        return "Mật khẩu phải có ít nhất 8 ký tự!";
      }
      if (this.password.length > 50) {
        return "Mật khẩu không được quá 50 ký tự!";
      }
      if (!/[A-Z]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!/[0-9]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])/;
      if (!re.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!((/[A-Z]/.test(this.password)) || (/[0-9]/.test(this.password)) || (re.test(this.password)) || (/[a-z]/.test(this.password))))
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      return "";
    },
    async existUsername() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/users/check_username_exist", {username: this.username, uid: this.uid}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    async existEmail() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/users/check_email_exist", {email: this.email, uid: this.uid}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        username: this.username,
        fullname: this.fullname,
        phone: this.phone,
        email: this.email,
        address: this.address,
        website: this.website,
        images: this.images,
        password: this?.password ? this.$commonFuction.hashPasswordAdmin(this.password) : null,
        modules: this.modules,
        company_group: this.company_group,
        company_type: this.company_type,
      };
      console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > 1) {
          alert("Chỉ được upload tối đa 1 ảnh");
          return;
        }
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Please upload the image file in the following format: jpeg, jpg, gif, png"
            );
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 50MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === "") {
              this.imagesDeletes.push(this.images[0]);
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
    showContent(index){
        this.currentTab = index
    },
    async LoadModuleUser(uid=null){
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var company_modules = await ApiRepository.post(Constants.API.MODULE_COMPANY, {company_id: uid}, {headers}).then(function (response) {
            var data = response?.data?.data ?? [];
            // console.log('data menu', data);
            return data
        }).catch(function (error) {
            console.log('error', error);
            return []
        });
        // console.log("company_modules", company_modules);
        this.modules = company_modules
      }
    },
    emitEventCompanyGroup(keyword) {
      this.$delete(this.company_group_obj.filters, 'name');
      if (keyword) {
        this.company_group_obj.filters.name = keyword;
      }
      this.getListCompanyGroup();
    },
    changeOffsetCompanyGroup(value) {
      this.company_group_obj.offset = value;
    },
    async getListCompanyGroup() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_group_obj.loading = true;
        await ApiRepository.post("/_api/company_group/options", {filters: this.company_group_obj.filters, limit: this.company_group_obj.limit, offset: this.company_group_obj.offset}, {headers}).then((res) => {
          if (this.company_group_obj.offset > 0 ) {
            this.company_group_obj.items.push(...res.data.data.list);
          } else{
            this.company_group_obj.items = res.data.data.list;
          }
          this.company_group_obj.total = res.data.data.total;
          this.company_group_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_group_obj.loading = false;
        })
      }
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}

.tab {
    display: flex;
    font-weight: 700;
    border-bottom: 1px solid #00000029;
}
.tab div {
    padding: 6px 8px;
    /* margin-right: 2px; */
    cursor: pointer;
}
.tab div.active {
    background-color: #fff;
    color: #0086C4;
    border-left: 1px solid #0086C4;
    border-right: 1px solid #0086C4;
    border-bottom: 3px solid #0086C4;
    border-top: 1px solid #0086C4;
}
.content {
    padding-top: 10px;
    display: none;
}
.content.active {
    display: block;
}
.hide-tab {
    display: none;
}
.module-item {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  /* width: 200px; */
}
.module-item:hover {
  background: #f7f7f7;
}
.module-item.active {
  background: #e6f7ff;
  border-color: #1890ff;
}
</style>
